import shoppingAssistantApiFactory from '../../modules/shoppingAssistant/shoppingAssistantApi';
import {sendMessageActionCreators, deleteChatActionCreators} from '../actions/shoppingAssistantActions';
import {
  generateDefaultAsyncSaga,
  generateDefaultAsyncWatcher,
} from '../core/reduxUtils';


function shoppingAssistantSagasFactory({storefrontApiClient}) {
  const shoppingAssistantApi = shoppingAssistantApiFactory(storefrontApiClient);

  const sendMessageSaga = generateDefaultAsyncSaga(
    shoppingAssistantApi.sendMessage,
    sendMessageActionCreators,
    (payload) => [payload.params]
  );

  const deleteChatSaga = generateDefaultAsyncSaga(
    shoppingAssistantApi.deleteChat,
    deleteChatActionCreators,
    (payload) => [payload.params]
  );


  const watchSendMessage = generateDefaultAsyncWatcher(
    'SEND_MESSAGE',
    sendMessageSaga
  );

  const watchDeleteChat = generateDefaultAsyncWatcher(
    'DELETE_CHAT',
    deleteChatSaga
  );

  return [watchSendMessage(), watchDeleteChat()];
}

export default shoppingAssistantSagasFactory;
